import React from 'react'

const ButtonBlock = ({ text, link, className = '' }) => {
  return (
    <a className={`slider__button-block ${className}`} href={link}>
      <div className="slider__button-box">
        <div className="slider__button-shape-left"></div>
        <div className="slider__button-center">
          <div className="slider__button-text">
            {text}
          </div>
          <div className="slider__button-arrow-box">
            <div className="slider__button-arrow-holder">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M12 5L19 12L12 19" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
              </svg>
            </div>
          </div>
        </div>
        <div className="slider__button-shape-right"></div>
      </div>
    </a>
  )
}

export default ButtonBlock;
